/** 交易阶梯任务 slug，与 SectionTradingTiers / SectionTasksGeneral 共用 */
export const TIER_SLUGS = [
  'DAILY_TRADING_FUTURES',
  // 'DAILY_TRADING_COPY',//目前不需要跟单系统的 先禁止
  'DAILY_TRADING_PREDICTING',
  'DAILY_TRADING_PREDICTION_LEVERAGE',
  'DAILY_TRADING_TAP_GRID',
];

/** 阶梯任务 slug → 对应「达到最高档」的 XP action */
export const TIER_SLUG_TOP_XP_ACTION: Record<string, string> = {
  DAILY_TRADING_FUTURES: 'DAILY_PERP_TOP',
  DAILY_TRADING_PREDICTING: 'DAILY_PREDICT_TOP',
  DAILY_TRADING_PREDICTION_LEVERAGE: 'DAILY_LEVERAGE_TOP',
  DAILY_TRADING_TAP_GRID: 'DAILY_TAP_GRID_TOP',
};
